import * as angular from 'angular';

class StorageLocationDetailsGeneralCtrl implements ng.IController {
    public isEditMode: boolean;
    public isCreateMode: boolean;
    public storageLocation: StorageLocationDto;
    public isEditable = this.isCreateMode || this.isEditMode;
    public generalExpanded: boolean = true;

    public newIndividualField: boolean = false;
    public newIndividualFieldKey: string;
    public newIndividualFieldValue: string;

    constructor() {}

    $onInit() {}

    public addIndividualField(): void {
        if (!this.storageLocation.fields) {
            this.storageLocation.fields = [];
        }

        let newField = <StorageLocationFieldDto>{};
        newField.key = this.newIndividualFieldKey;
        newField.value = this.newIndividualFieldValue;

        this.storageLocation.fields.push(newField);

        this.newIndividualFieldKey = null;
        this.newIndividualFieldValue = null;
        this.newIndividualField = false;
    }

    public removeIndividualField(index): void {
        this.storageLocation.fields.splice(index, 1);
    }
}

angular.module('app').component('pkpStorageLocationDetailsGeneral', {
    controller: StorageLocationDetailsGeneralCtrl,
    template:
        require('app/storage-location/storage-location-details-general.component.html'),
    bindings: {
        form: '<',
        storageLocation: '=',
        isEditMode: '<',
        isCreateMode: '<'
    }
});
